import { render, staticRenderFns } from "./ErrorWarningCard.vue?vue&type=template&id=a5355d4c&scoped=true&"
import script from "./ErrorWarningCard.vue?vue&type=script&lang=js&"
export * from "./ErrorWarningCard.vue?vue&type=script&lang=js&"
import style0 from "./ErrorWarningCard.vue?vue&type=style&index=0&id=a5355d4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5355d4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VIcon,VLayout})
